import { useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import { Stock, StockData, StockTickerProps } from "@app/types/Stocks";
import cx from "classnames";
import { truncate } from "lodash-es";

import { fetchRequests } from "./StockTicker.server";
import StockTickerArrows from "./StockTickerArrows";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function StockTicker({
  className,
  testId,
}: StockTickerProps): React.ReactElement {
  const [stocks, setStocks] = useState<StockData>();

  const SliderComponent =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    typeof window === "undefined" ? Slider.default : Slider;

  useEffect(() => {
    const fetchStocks = async () => {
      const stockData = await fetchRequests.fetchStocksData();

      setStocks(stockData);
    };

    fetchStocks();
  }, [setStocks]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    variableWidth: true,
    className: "stock-ticker font-poppins lg:pr-16",
    prevArrow: <StockTickerArrows direction="left" />,
    nextArrow: <StockTickerArrows direction="right" />,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
    ],
  } as Settings;

  return (
    <>
      <div
        className={cx(
          className,
          "relative border-b border-t border-gray-175 py-2"
        )}
        data-testid={testId}
      >
        <SliderComponent {...settings}>
          {stocks?.stocks.map((stock: Stock, index: number) => {
            return (
              <div
                className={cx("!flex snap-start items-center gap-1 pr-4")}
                key={index}
              >
                <span
                  className="whitespace-nowrap text-xs font-semibold"
                  title={stock.name}
                >
                  {truncate(stock.name, { length: 16 })}
                </span>
                <span
                  className={cx("text-4xs", {
                    "hidden md:inline": stock.direction !== "unchanged",
                  })}
                >
                  {` ${stock.last_done}`}
                </span>
                <span
                  className={cx("rounded px-1 text-4xs font-semibold", {
                    "hidden md:inline": stock.direction === "unchanged",
                    border: stock.direction !== "unchanged",
                    "border-green-300 text-green-300": stock.direction === "up",
                    "border-red text-red": stock.direction === "down",
                  })}
                >
                  {stock.change}
                </span>
              </div>
            );
          })}
        </SliderComponent>
      </div>
    </>
  );
}
